import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=4ca5a01e&scoped=true&lang=pug&"
var script = {}
import style0 from "./Legal.vue?vue&type=style&index=0&id=4ca5a01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5a01e",
  null
  
)

export default component.exports